'use client';

import { useMemo } from 'react';

import { useSuspensions, useValidators } from '@personly/libs-providers';
import { Button } from '@personly/libs-widgets';

import { useEmails } from '@/providers/emails';
import { useLegalTerms } from '@/providers/legalTerms';
import { usePasswords } from '@/providers/passwords';

interface Props {
  children: string;
}

const RegisterSubmitButton = ({ children }: Props) => {
  const { email } = useEmails();
  const { password } = usePasswords();
  const { validate } = useValidators();
  const { suspended } = useSuspensions();
  const { privacyPolicyAccepted, termsOfServiceAccepted } = useLegalTerms();

  const blocked = useMemo(
    () => suspended('CAPTCHA') === 'STARTED',
    [suspended]
  );

  const disabled = useMemo(
    () =>
      !validate('EMAIL', email) ||
      !validate('PASSWORD', password) ||
      !privacyPolicyAccepted ||
      !termsOfServiceAccepted ||
      blocked,
    [
      email,
      password,
      blocked,
      privacyPolicyAccepted,
      termsOfServiceAccepted,
      validate,
    ]
  );

  return (
    <Button block type="submit" disabled={disabled}>
      {children}
    </Button>
  );
};

export default RegisterSubmitButton;
